import React, { useState, useEffect } from "react";
import Routes from "./Routes";
import { notificationsService } from './services/supabaseService';
import AIMatchNotification from './components/ui/AIMatchNotification';
import { useAuth } from './contexts/AuthContext';

function App() {
  const [aiNotification, setAiNotification] = React.useState(null);
  const { user } = useAuth();
  
  React.useEffect(() => {
    if (user?.id) {
      // Subscribe to AI matching notifications
      const channel = notificationsService?.subscribeToNotifications(
        user?.id,
        (notification) => {
          // Show notification for AI matching events
          const aiTypes = ['NEW_AI_MATCH', 'EMERGENCY_REMATCH', 'REMATCH_FAILED', 'DELAY_NOTIFICATION'];
          if (aiTypes?.includes(notification?.type)) {
            setAiNotification(notification);
            
            // Auto-hide after 10 seconds
            setTimeout(() => {
              setAiNotification(null);
            }, 10000);
          }
        }
      );
      
      return () => {
        notificationsService?.unsubscribe(channel);
      };
    }
  }, [user]);
  
  return (
    <>
      <Routes />
      {aiNotification && (
        <AIMatchNotification
          notification={aiNotification}
          onClose={() => setAiNotification(null)}
        />
      )}
    </>
  );
}

export default App;
